module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/7-ba2a2f93e6c66c31d1ce08456d3bb4cb.jpg";